import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';

export default (el, props) => {
    const $el = $(el);
    const $inner = $el.find('[data-popup-inner]');
    const $closebtn = $el.find('[data-popup-close-button]');
    const $linkbtn = $el.find('[data-popup-link-button]');

    const open = () => {
        TweenMax.set($el.get(0), { display: 'flex', opacity: 0 });
        TweenMax.set($inner.get(0), { opacity: 0, y: 50 });

        TweenMax.to($el.get(0), 0.3, { opacity: 1, ease: 'Sine.easeOut' });
        TweenMax.to($inner.get(0), 0.2, { delay: 0.4, opacity: 1, ease: 'Sine.easeOut' });
        TweenMax.to($inner.get(0), 0.6, { delay: 0.4, y: 0, ease: 'Quint.easeOut' });
    };

    const close = () => {
        window.vrsg.setCookie('newsletterPopupClosed', '1', 7);
        TweenMax.to($el.get(0), 0.1, {
            opacity: 0, ease: 'Sine.easeOut', onComplete: () => {
                $el.css({ display: 'none' });
            }
        });
    };

    const init = () => {
        $closebtn.on('click', () => {
            close();
        });

        $linkbtn.on('click', () => {
            close();
        });
        
        if (window.vrsg.getCookie('newsletterPopupClosed') !== '1') {
            setTimeout(() => {
                open();
            }, 30000);
        }
    };

    const destroy = () => {
        $closebtn.off('click');
        $linkbtn.off('click');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/NewsletterPopup.js